const localWeatherDummy = {
  generalSituation:
    "The northeast monsoon is affecting the coast of southern China. Meanwhile, a broad band of clouds is covering the region.",
  tcInfo: "",
  fireDangerWarning: "",
  forecastPeriod: "Weather forecast for today",
  forecastDesc:
    "Mainly cloudy. One or two light rain patches in the morning. Temperatures will range between 21 and 24 degrees. Moderate to fresh easterly winds, occasionally strong offshore at first.",
  outlook:
    "One or two rain patches on Friday. More showers on Saturday. Showers will lessen early next week.",
  updateTime: "2023-04-27T02:45:00+08:00",
};

const futureWeathersDummy = [
  {
    forecastDate: "20230429",
    week: "星期六",
    forecastWind: "東至東南風2至3級，稍後北風4級。",
    forecastWeather: "大致多雲，有幾陣驟雨及雷暴。初時部分地區能見度較低。",
    forecastMaxtemp: {
      value: 27,
      unit: "C",
    },
    forecastMintemp: {
      value: 22,
      unit: "C",
    },
    forecastMaxrh: {
      value: 95,
      unit: "percent",
    },
    forecastMinrh: {
      value: 75,
      unit: "percent",
    },
    ForecastIcon: 62,
    PSR: "中",
  },
];

const weatherReportDummy = {
  rainfall: {
    data: [
      {
        unit: "mm",
        place: "中西區",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "東區",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "葵青",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "離島區",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "北區",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "西貢",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "沙田",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "南區",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "大埔",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "荃灣",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "屯門",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "灣仔",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "元朗",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "油尖旺",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "深水埗",
        max: 0,
        main: "",
      },
      {
        unit: "mm",
        place: "九龍城",
        max: 0,
        main: "",
      },
      {
        unit: "mm",
        place: "黃大仙",
        max: 0,
        main: "FALSE",
      },
      {
        unit: "mm",
        place: "觀塘",
        max: 0,
        main: "FALSE",
      },
    ],
    startTime: "2023-04-27T13:45:00+08:00",
    endTime: "2023-04-27T14:45:00+08:00",
  },
  warningMessage: "",
  icon: [52],
  iconUpdateTime: "2023-04-27T11:45:00+08:00",
  uvindex: {
    data: [
      {
        place: "京士柏",
        value: 4,
        desc: "中等",
      },
    ],
    recordDesc: "過去一小時",
  },
  updateTime: "2023-04-27T15:02:00+08:00",
  temperature: {
    data: [
      {
        place: "京士柏",
        value: 24,
        unit: "C",
      },
      {
        place: "香港天文台",
        value: 24,
        unit: "C",
      },
      {
        place: "黃竹坑",
        value: 25,
        unit: "C",
      },
      {
        place: "打鼓嶺",
        value: 24,
        unit: "C",
      },
      {
        place: "流浮山",
        value: 27,
        unit: "C",
      },
      {
        place: "大埔",
        value: 23,
        unit: "C",
      },
      {
        place: "沙田",
        value: 24,
        unit: "C",
      },
      {
        place: "屯門",
        value: 25,
        unit: "C",
      },
      {
        place: "將軍澳",
        value: 23,
        unit: "C",
      },
      {
        place: "西貢",
        value: 23,
        unit: "C",
      },
      {
        place: "長洲",
        value: 23,
        unit: "C",
      },
      {
        place: "赤鱲角",
        value: 25,
        unit: "C",
      },
      {
        place: "青衣",
        value: 25,
        unit: "C",
      },
      {
        place: "石崗",
        value: 25,
        unit: "C",
      },
      {
        place: "荃灣城門谷",
        value: 25,
        unit: "C",
      },
      {
        place: "香港公園",
        value: 23,
        unit: "C",
      },
      {
        place: "筲箕灣",
        value: 22,
        unit: "C",
      },
      {
        place: "九龍城",
        value: 24,
        unit: "C",
      },
      {
        place: "跑馬地",
        value: 25,
        unit: "C",
      },
      {
        place: "黃大仙",
        value: 25,
        unit: "C",
      },
      {
        place: "赤柱",
        value: 23,
        unit: "C",
      },
      {
        place: "觀塘",
        value: 23,
        unit: "C",
      },
      {
        place: "深水埗",
        value: 25,
        unit: "C",
      },
      {
        place: "啟德跑道公園",
        value: 24,
        unit: "C",
      },
      {
        place: "元朗公園",
        value: 27,
        unit: "C",
      },
      {
        place: "大美督",
        value: 23,
        unit: "C",
      },
    ],
    recordTime: "2023-04-27T15:00:00+08:00",
  },
  tcmessage: "",
  mintempFrom00To09: "",
  rainfallFrom00To12: "",
  rainfallLastMonth: "",
  rainfallJanuaryToLastMonth: "",
  humidity: {
    recordTime: "2023-04-27T15:00:00+08:00",
    data: [
      {
        unit: "percent",
        value: 74,
        place: "香港天文台",
      },
    ],
  },
};

const warningSummaryDummy = {};

const warningInfoDummy = {};
const weatherTipsDummy = [];

export {
  localWeatherDummy,
  futureWeathersDummy,
  weatherReportDummy,
  warningSummaryDummy,
  warningInfoDummy,
  weatherTipsDummy,
};
